import React, { useEffect, useState } from "react";
import { useAuthContext } from "./../../../contexts/auth.context";
import { getStorageItem, setStorageItem } from "../../../helpers/shared-info";
import constant, {
  AccelerometerSensor,
  BatterySensor,
  GeoLocationSensor,
  MicrophoneSensor,
  WeekDays,
  WeekNames,
} from "../../../helpers/constant";
import { useSensorContext } from "../../../contexts/sensor.context";
import packageJson from "./../../../../../package.json";

const Settings = () => {
  const existingFrequency = (type) => {
    return getStorageItem(type)?.frequency || constant.defaultFrequency;
  };

  const { logout } = useAuthContext();
  const [facceleromoter, setFAccelerometer] = useState(
    existingFrequency(AccelerometerSensor.id)
  );
  const [fbattery, setFBattery] = useState(existingFrequency(BatterySensor.id));
  const [flocation, setFLocation] = useState(
    existingFrequency(GeoLocationSensor.id)
  );
  const [fmic, setFMic] = useState(existingFrequency(MicrophoneSensor.id));

  const renderLogout = () => {
    return (
      <button className="btn btn-danger" onClick={() => logout()}>
        Logout
      </button>
    );
  };

  const renderAccelerometer = () => {
    return (
      <div className="accordion-item">
        <div className="accordion-header">
          <div
            className="accordion-button collapsed nvh-gap-2 pb-1 d-flex align-items-center"
            data-bs-toggle="collapse"
            data-bs-target="#collapseGyroscope"
            aria-expanded="true"
            aria-controls="collapseGyroscope"
          >
            <svg width="25" height="25" viewBox="0 0 38 38" fill="black">
              <path d="M19 3.16669L25.3333 9.50002H20.5833V21.9292L30.9225 27.8825L33.25 23.7975L35.625 32.4584L26.9167 34.77L29.3392 30.6375L19 24.6684L8.66083 30.6375L11.0833 34.77L2.375 32.4584L4.75 23.7975L7.0775 27.8825L17.4167 21.9292V9.50002H12.6667L19 3.16669Z" />
            </svg>
            <div>Accelerometer, Gyroscope, Magnetometer</div>
          </div>
        </div>
        <div
          id="collapseGyroscope"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body pt-2 pb-4">
            <FrequencyInput
              id={AccelerometerSensor.id}
              title={"Sampling Frequency"}
              placeholder={"Sample per minute"}
              value={facceleromoter}
              onChange={(e) => setFAccelerometer(e)}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderBattery = () => {
    return (
      <div className="accordion-item">
        <div className="accordion-header">
          <div
            className="accordion-button collapsed nvh-gap-2 pb-1 d-flex align-items-center"
            data-bs-toggle="collapse"
            data-bs-target="#collapseBattery"
            aria-expanded="true"
            aria-controls="collapseBattery"
          >
            <svg width="25" height="25" viewBox="0 0 40 40" fill="black">
              <path d="M24.4492 4.49219C24.2188 4.49219 23.9844 4.55469 23.7695 4.69922L9.92188 13.75H3.51562C3.17187 13.75 2.89062 14.0312 2.89062 14.375V25.625C2.89062 25.9688 3.17187 26.25 3.51562 26.25H9.92188L23.7695 35.3008C23.9844 35.4414 24.2227 35.5078 24.4492 35.5078C25.1016 35.5078 25.7031 34.9883 25.7031 34.2539V5.74609C25.7031 5.01172 25.1016 4.49219 24.4492 4.49219ZM22.8906 31.3672L11.4609 23.8945L10.7578 23.4375H5.70312V16.5625H10.7578L11.457 16.1055L22.8906 8.63281V31.3672ZM36.4844 18.5938H31.4844C31.1406 18.5938 30.8594 18.875 30.8594 19.2188V20.7812C30.8594 21.125 31.1406 21.4062 31.4844 21.4062H36.4844C36.8281 21.4062 37.1094 21.125 37.1094 20.7812V19.2188C37.1094 18.875 36.8281 18.5938 36.4844 18.5938ZM34.8477 28.8203L30.5391 26.332C30.4683 26.2915 30.3902 26.2653 30.3093 26.255C30.2284 26.2446 30.1462 26.2503 30.0675 26.2717C29.9888 26.2931 29.9151 26.3298 29.8505 26.3797C29.786 26.4296 29.7319 26.4917 29.6914 26.5625L28.9141 27.9102C28.7422 28.207 28.8438 28.5898 29.1406 28.7617L33.4492 31.25C33.52 31.2905 33.5981 31.3167 33.679 31.3271C33.7599 31.3374 33.8421 31.3317 33.9208 31.3103C33.9995 31.2889 34.0732 31.2522 34.1378 31.2023C34.2023 31.1524 34.2564 31.0903 34.2969 31.0195L35.0742 29.6719C35.2461 29.375 35.1406 28.9922 34.8477 28.8203ZM29.6875 13.4375C29.728 13.5083 29.7821 13.5704 29.8466 13.6203C29.9112 13.6702 29.9849 13.7069 30.0636 13.7283C30.1423 13.7497 30.2245 13.7554 30.3054 13.745C30.3863 13.7347 30.4644 13.7085 30.5352 13.668L34.8438 11.1797C35.1406 11.0078 35.2422 10.625 35.0703 10.3281L34.2969 8.98438C34.2564 8.91358 34.2023 8.85146 34.1378 8.80156C34.0732 8.75166 33.9995 8.71497 33.9208 8.69357C33.8421 8.67216 33.7599 8.66648 33.679 8.67683C33.5981 8.68718 33.52 8.71337 33.4492 8.75391L29.1406 11.2422C28.998 11.3254 28.894 11.4616 28.8516 11.6212C28.8091 11.7808 28.8316 11.9507 28.9141 12.0938L29.6875 13.4375Z" />
            </svg>
            <div>Battery</div>
          </div>
        </div>
        <div
          id="collapseBattery"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body pt-2 pb-4">
            <FrequencyInput
              id={BatterySensor.id}
              title={"Sample per minute"}
              placeholder={"sample per minute"}
              value={fbattery}
              onChange={(e) => setFBattery(e)}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderLocation = () => {
    return (
      <div className="accordion-item">
        <div className="accordion-header">
          <div
            className="accordion-button collapsed nvh-gap-2 pb-1 d-flex align-items-center"
            data-bs-toggle="collapse"
            data-bs-target="#collapseLocation"
            aria-expanded="true"
            aria-controls="collapseLocation"
          >
            <svg width="25" height="25" viewBox="0 0 41 41" fill="black">
              <path d="M20.5 5.12504C17.3285 5.12504 14.2868 6.38493 12.0442 8.62755C9.80156 10.8702 8.54167 13.9118 8.54167 17.0834C8.54167 21.9726 11.5859 26.6893 14.9274 30.3435C16.636 32.2049 18.5003 33.9172 20.5 35.4616C20.7984 35.2327 21.1486 34.9537 21.5506 34.6245C23.1561 33.3062 24.6672 31.8768 26.0726 30.3469C29.4141 26.6893 32.4583 21.9743 32.4583 17.0834C32.4583 13.9118 31.1984 10.8702 28.9558 8.62755C26.7132 6.38493 23.6715 5.12504 20.5 5.12504ZM20.5 39.6573L19.5314 38.991L19.5263 38.9876L19.516 38.9791L19.4818 38.9552L19.3537 38.8646L18.8925 38.5281C16.5552 36.7715 14.384 34.8044 12.4059 32.6514C8.91408 28.8282 5.125 23.2949 5.125 17.0817C5.125 13.004 6.74486 9.09327 9.62823 6.2099C12.5116 3.32653 16.4223 1.70667 20.5 1.70667C24.5777 1.70667 28.4884 3.32653 31.3718 6.2099C34.2551 9.09327 35.875 13.004 35.875 17.0817C35.875 23.2949 32.0859 28.8299 28.5941 32.648C26.6166 34.8009 24.4459 36.768 22.1093 38.5247C21.9146 38.6701 21.7181 38.813 21.5199 38.9535L21.484 38.9774L21.4737 38.9859L21.4703 38.9876L20.5 39.6573ZM20.5 13.6667C19.5938 13.6667 18.7248 14.0267 18.0841 14.6674C17.4433 15.3082 17.0833 16.1772 17.0833 17.0834C17.0833 17.9895 17.4433 18.8586 18.0841 19.4993C18.7248 20.1401 19.5938 20.5 20.5 20.5C21.4062 20.5 22.2752 20.1401 22.9159 19.4993C23.5567 18.8586 23.9167 17.9895 23.9167 17.0834C23.9167 16.1772 23.5567 15.3082 22.9159 14.6674C22.2752 14.0267 21.4062 13.6667 20.5 13.6667ZM13.6667 17.0834C13.6667 15.2711 14.3866 13.533 15.6681 12.2515C16.9496 10.97 18.6877 10.25 20.5 10.25C22.3123 10.25 24.0504 10.97 25.3319 12.2515C26.6134 13.533 27.3333 15.2711 27.3333 17.0834C27.3333 18.8957 26.6134 20.6338 25.3319 21.9153C24.0504 23.1968 22.3123 23.9167 20.5 23.9167C18.6877 23.9167 16.9496 23.1968 15.6681 21.9153C14.3866 20.6338 13.6667 18.8957 13.6667 17.0834Z" />
            </svg>
            <div>Location</div>
          </div>
        </div>
        <div
          id="collapseLocation"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body pt-2 pb-4">
            <FrequencyInput
              id={GeoLocationSensor.id}
              title={"Sample per minute"}
              placeholder={"Sample per minute"}
              value={flocation}
              onChange={(e) => setFLocation(e)}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderMicrophone = () => {
    return (
      <div className="accordion-item">
        <div className="accordion-header">
          <div
            className="accordion-button collapsed nvh-gap-2 pb-1 d-flex align-items-center"
            data-bs-toggle="collapse"
            data-bs-target="#collapseMicrophone"
            aria-expanded="true"
            aria-controls="collapseMicrophone"
          >
            <svg width="25" height="25" viewBox="0 0 40 40" fill="black">
              <path d="M24.4492 4.49219C24.2188 4.49219 23.9844 4.55469 23.7695 4.69922L9.92188 13.75H3.51562C3.17187 13.75 2.89062 14.0312 2.89062 14.375V25.625C2.89062 25.9688 3.17187 26.25 3.51562 26.25H9.92188L23.7695 35.3008C23.9844 35.4414 24.2227 35.5078 24.4492 35.5078C25.1016 35.5078 25.7031 34.9883 25.7031 34.2539V5.74609C25.7031 5.01172 25.1016 4.49219 24.4492 4.49219ZM22.8906 31.3672L11.4609 23.8945L10.7578 23.4375H5.70312V16.5625H10.7578L11.457 16.1055L22.8906 8.63281V31.3672ZM36.4844 18.5938H31.4844C31.1406 18.5938 30.8594 18.875 30.8594 19.2188V20.7812C30.8594 21.125 31.1406 21.4062 31.4844 21.4062H36.4844C36.8281 21.4062 37.1094 21.125 37.1094 20.7812V19.2188C37.1094 18.875 36.8281 18.5938 36.4844 18.5938ZM34.8477 28.8203L30.5391 26.332C30.4683 26.2915 30.3902 26.2653 30.3093 26.255C30.2284 26.2446 30.1462 26.2503 30.0675 26.2717C29.9888 26.2931 29.9151 26.3298 29.8505 26.3797C29.786 26.4296 29.7319 26.4917 29.6914 26.5625L28.9141 27.9102C28.7422 28.207 28.8438 28.5898 29.1406 28.7617L33.4492 31.25C33.52 31.2905 33.5981 31.3167 33.679 31.3271C33.7599 31.3374 33.8421 31.3317 33.9208 31.3103C33.9995 31.2889 34.0732 31.2522 34.1378 31.2023C34.2023 31.1524 34.2564 31.0903 34.2969 31.0195L35.0742 29.6719C35.2461 29.375 35.1406 28.9922 34.8477 28.8203ZM29.6875 13.4375C29.728 13.5083 29.7821 13.5704 29.8466 13.6203C29.9112 13.6702 29.9849 13.7069 30.0636 13.7283C30.1423 13.7497 30.2245 13.7554 30.3054 13.745C30.3863 13.7347 30.4644 13.7085 30.5352 13.668L34.8438 11.1797C35.1406 11.0078 35.2422 10.625 35.0703 10.3281L34.2969 8.98438C34.2564 8.91358 34.2023 8.85146 34.1378 8.80156C34.0732 8.75166 33.9995 8.71497 33.9208 8.69357C33.8421 8.67216 33.7599 8.66648 33.679 8.67683C33.5981 8.68718 33.52 8.71337 33.4492 8.75391L29.1406 11.2422C28.998 11.3254 28.894 11.4616 28.8516 11.6212C28.8091 11.7808 28.8316 11.9507 28.9141 12.0938L29.6875 13.4375Z" />
            </svg>
            <div>Microphone</div>
          </div>
        </div>
        <div
          id="collapseMicrophone"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body pt-2 pb-4">
            <FrequencyInput
              id={MicrophoneSensor.id}
              title={"Sample per minute"}
              placeholder={"Sample per minute"}
              value={fmic}
              onChange={(e) => setFMic(e)}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderSchedule = () => {
    return (
      <div className="accordion-item">
        <div className="accordion-header">
          <div
            className="accordion-button collapsed nvh-gap-2 pb-1 d-flex align-items-center"
            data-bs-toggle="collapse"
            data-bs-target="#collapseSchedule"
            aria-expanded="true"
            aria-controls="collapseSchedule"
          >
            <svg width="25" height="25" viewBox="0 0 40 40" fill="black">
              <path d="M24.4492 4.49219C24.2188 4.49219 23.9844 4.55469 23.7695 4.69922L9.92188 13.75H3.51562C3.17187 13.75 2.89062 14.0312 2.89062 14.375V25.625C2.89062 25.9688 3.17187 26.25 3.51562 26.25H9.92188L23.7695 35.3008C23.9844 35.4414 24.2227 35.5078 24.4492 35.5078C25.1016 35.5078 25.7031 34.9883 25.7031 34.2539V5.74609C25.7031 5.01172 25.1016 4.49219 24.4492 4.49219ZM22.8906 31.3672L11.4609 23.8945L10.7578 23.4375H5.70312V16.5625H10.7578L11.457 16.1055L22.8906 8.63281V31.3672ZM36.4844 18.5938H31.4844C31.1406 18.5938 30.8594 18.875 30.8594 19.2188V20.7812C30.8594 21.125 31.1406 21.4062 31.4844 21.4062H36.4844C36.8281 21.4062 37.1094 21.125 37.1094 20.7812V19.2188C37.1094 18.875 36.8281 18.5938 36.4844 18.5938ZM34.8477 28.8203L30.5391 26.332C30.4683 26.2915 30.3902 26.2653 30.3093 26.255C30.2284 26.2446 30.1462 26.2503 30.0675 26.2717C29.9888 26.2931 29.9151 26.3298 29.8505 26.3797C29.786 26.4296 29.7319 26.4917 29.6914 26.5625L28.9141 27.9102C28.7422 28.207 28.8438 28.5898 29.1406 28.7617L33.4492 31.25C33.52 31.2905 33.5981 31.3167 33.679 31.3271C33.7599 31.3374 33.8421 31.3317 33.9208 31.3103C33.9995 31.2889 34.0732 31.2522 34.1378 31.2023C34.2023 31.1524 34.2564 31.0903 34.2969 31.0195L35.0742 29.6719C35.2461 29.375 35.1406 28.9922 34.8477 28.8203ZM29.6875 13.4375C29.728 13.5083 29.7821 13.5704 29.8466 13.6203C29.9112 13.6702 29.9849 13.7069 30.0636 13.7283C30.1423 13.7497 30.2245 13.7554 30.3054 13.745C30.3863 13.7347 30.4644 13.7085 30.5352 13.668L34.8438 11.1797C35.1406 11.0078 35.2422 10.625 35.0703 10.3281L34.2969 8.98438C34.2564 8.91358 34.2023 8.85146 34.1378 8.80156C34.0732 8.75166 33.9995 8.71497 33.9208 8.69357C33.8421 8.67216 33.7599 8.66648 33.679 8.67683C33.5981 8.68718 33.52 8.71337 33.4492 8.75391L29.1406 11.2422C28.998 11.3254 28.894 11.4616 28.8516 11.6212C28.8091 11.7808 28.8316 11.9507 28.9141 12.0938L29.6875 13.4375Z" />
            </svg>
            <div>Schedule</div>
          </div>
        </div>
        <div
          id="collapseSchedule"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body pt-2 pb-4 nvh-gap-3 d-flex flex-column">
            {renderWeekTimePicker()}
          </div>
        </div>
      </div>
    );
  };

  const renderWeekTimePicker = () => {
    return (
      <>
        <TimePicker title={WeekDays.Monday} />
        <TimePicker title={WeekDays.Tuesday} />
        <TimePicker title={WeekDays.Wednesday} />
        <TimePicker title={WeekDays.Thursday} />
        <TimePicker title={WeekDays.Friday} />
        <TimePicker title={WeekDays.Saturday} />
        <TimePicker title={WeekDays.Sunday} />
      </>
    );
  };

  const renderAppSetting = () => {
    return (
      <>
        {renderSettingHeader()}
        <div className="accordion" id="accordionExample">
          {renderAccelerometer()}
          {renderBattery()}
          {renderLocation()}
          {renderMicrophone()}
          {renderSchedule()}
        </div>
      </>
    );
  };

  const renderSettingHeader = () => {
    return (
      <div className="d-flex align-items-center px-3 mb-0 nvh-gap-2">
        <div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 2C15.668 1.99982 14.8468 2.18841 14.0982 2.55157C13.3496 2.91472 12.6932 3.44298 12.1783 4.09656C11.6635 4.75014 11.3036 5.51202 11.1258 6.32482C10.9481 7.13762 10.957 7.98016 11.152 8.789L2.841 17.1C2.56998 17.3656 2.3543 17.6823 2.20643 18.0318C2.05857 18.3812 1.98145 18.7565 1.97953 19.136C1.97761 19.5155 2.05094 19.8915 2.19527 20.2425C2.3396 20.5934 2.55207 20.9123 2.82039 21.1806C3.08871 21.4489 3.40756 21.6614 3.75851 21.8057C4.10946 21.9501 4.48553 22.0234 4.86499 22.0215C5.24445 22.0196 5.61977 21.9424 5.96924 21.7946C6.31871 21.6467 6.6354 21.431 6.901 21.16L11.016 17.047C11.0888 16.0003 11.414 14.9869 11.9636 14.0932C12.5133 13.1995 13.2711 12.4521 14.1723 11.9149C15.0735 11.3777 16.0914 11.0667 17.139 11.0084C18.1866 10.95 19.2327 11.1462 20.188 11.58C20.7585 11.0644 21.2145 10.4349 21.5266 9.73211C21.8387 9.02935 22 8.26895 22 7.5C22.0007 6.90693 21.9055 6.31766 21.718 5.755C21.6774 5.63378 21.6066 5.52493 21.5121 5.43879C21.4177 5.35266 21.3028 5.29208 21.1784 5.26283C21.054 5.23357 20.9241 5.23661 20.8012 5.27164C20.6782 5.30667 20.5663 5.37255 20.476 5.463L18.032 7.907C17.8914 8.04745 17.7007 8.12634 17.502 8.12634C17.3032 8.12634 17.1126 8.04745 16.972 7.907L16.093 7.029C15.9525 6.88838 15.8737 6.69775 15.8737 6.499C15.8737 6.30025 15.9525 6.10963 16.093 5.969L18.538 3.524C18.6282 3.4336 18.6938 3.32166 18.7286 3.1988C18.7635 3.07594 18.7664 2.94621 18.737 2.82193C18.7077 2.69764 18.6471 2.5829 18.561 2.48859C18.4749 2.39428 18.3661 2.32351 18.245 2.283C17.6824 2.09519 17.0931 1.99963 16.5 2ZM14.277 13.976C14.3516 14.2345 14.3733 14.5055 14.3407 14.7726C14.3082 15.0397 14.222 15.2975 14.0875 15.5306C13.953 15.7636 13.7728 15.9671 13.5577 16.1289C13.3427 16.2906 13.0972 16.4073 12.836 16.472L12.252 16.616C12.1578 17.2151 12.1598 17.8255 12.258 18.424L12.798 18.554C13.0616 18.6175 13.3095 18.7339 13.5267 18.8962C13.7439 19.0585 13.9258 19.2632 14.0614 19.4979C14.1971 19.7327 14.2835 19.9926 14.3156 20.2618C14.3477 20.531 14.3247 20.8039 14.248 21.064L14.061 21.695C14.501 22.081 15.001 22.394 15.546 22.617L16.039 22.098C16.2258 21.9015 16.4507 21.745 16.6998 21.6381C16.949 21.5312 17.2173 21.476 17.4885 21.476C17.7597 21.476 18.028 21.5312 18.2772 21.6381C18.5263 21.745 18.7512 21.9015 18.938 22.098L19.437 22.623C19.9779 22.4024 20.4787 22.0939 20.919 21.71L20.721 21.024C20.6464 20.7654 20.6248 20.4944 20.6574 20.2272C20.69 19.96 20.7762 19.7022 20.9109 19.4692C21.0455 19.2361 21.2258 19.0326 21.441 18.8709C21.6561 18.7092 21.9017 18.5926 22.163 18.528L22.746 18.384C22.8402 17.7849 22.8382 17.1745 22.74 16.576L22.2 16.446C21.9365 16.3824 21.6887 16.2659 21.4716 16.1036C21.2545 15.9413 21.0727 15.7365 20.9372 15.5018C20.8017 15.267 20.7153 15.0072 20.6833 14.738C20.6513 14.4688 20.6743 14.196 20.751 13.936L20.937 13.306C20.4967 12.9187 19.9953 12.6071 19.453 12.384L18.96 12.902C18.7732 13.0987 18.5483 13.2553 18.299 13.3623C18.0497 13.4693 17.7813 13.5245 17.51 13.5245C17.2387 13.5245 16.9703 13.4693 16.721 13.3623C16.4717 13.2553 16.2468 13.0987 16.06 12.902L15.562 12.377C15.018 12.597 14.518 12.907 14.079 13.289L14.277 13.976ZM17.5 19C16.7 19 16.05 18.328 16.05 17.5C16.05 16.672 16.7 16 17.5 16C18.3 16 18.95 16.672 18.95 17.5C18.95 18.328 18.3 19 17.5 19Z"
              fill="#3B4867"
            />
          </svg>
        </div>
        <div className="fw-bold" style={{ fontSize: 18, color: "#3b4767" }}>
          Feature Settings
        </div>
      </div>
    );
  };
  const renderAppVersion = () => {
    return (
      <div className="d-flex justify-content-center">
        App Version: v{packageJson.version}
      </div>
    );
  };

  const render = () => {
    return (
      <section className="settinsec py-3">
        {renderAppVersion()}
        {renderAppSetting()}
      </section>
    );
  };
  return render();
};

export default Settings;

const FrequencyInput = (props) => {
  const { id, value, onChange, placeholder, title } = props;
  const [edit, setEdit] = useState(false);
  const { recording } = useSensorContext();

  const onSave = () => {
    setEdit(false);
    let data = getStorageItem(id);
    data = { ...data, frequency: value };
    setStorageItem(id, data);
  };

  const renderAction = () => {
    if (edit) {
      return (
        <button
          className="btn-setting-icon btn-save"
          onClick={() => onSave()}
          disabled={!value}
        >
          <svg
            width="30"
            height="37"
            viewBox="0 0 40 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M35.1641 3.16797L15.8359 24.5197L7 16.5037L2 21.1287L16.6641 34.543L40 6.79297L35.1641 3.16797Z"
              fill="#149557"
            />
          </svg>
        </button>
      );
    }
    return (
      <button
        className="btn-setting-icon btn-edit"
        onClick={() => setEdit(true)}
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.4333 15L25 16.5667L9.86667 31.6667H8.33333V30.1333L23.4333 15ZM29.4333 5C29.0167 5 28.5833 5.16667 28.2667 5.48333L25.2167 8.53333L31.4667 14.7833L34.5167 11.7333C35.1667 11.0833 35.1667 10 34.5167 9.38333L30.6167 5.48333C30.2833 5.15 29.8667 5 29.4333 5ZM23.4333 10.3167L5 28.75V35H11.25L29.6833 16.5667L23.4333 10.3167Z"
            fill="#007bff"
          />
        </svg>
      </button>
    );
  };

  const onInputChange = (e) => {
    if (/^\d*\.?\d*$/.test(e)) {
      onChange(e);
    }
  };
  const render = () => {
    return (
      <div className={`accordion-body pt-2 pb-4`}>
        <h6 className="mb-2">{title}</h6>
        <div className="d-flex justify-content-start nvh-gap-2 align-items-lg-baseline">
          <input
            type="text"
            className="form-control text-dark"
            placeholder={placeholder}
            value={value}
            disabled={!edit || recording}
            maxLength={5}
            onChange={(e) => onInputChange(e.target.value)}
          />
          {renderAction()}
        </div>
      </div>
    );
  };
  return render();
};

const TimePicker = (props) => {
  const { title } = props;
  const getShedule = () => getStorageItem(constant.STORAGE.sheduleConfig);

  const [config, setConfig] = useState(
    getShedule()?.[title] || { start: "", end: "", enabled: false }
  );

  const [edit, setEdit] = useState(false);
  const { recording } = useSensorContext();

  useEffect(() => {}, [config]);

  const renderAction = () => {
    if (edit) {
      return (
        <div className="">
          <button
            className="btn-setting-icon btn-save"
            onClick={() => updateConfig()}
          >
            <svg
              width="30"
              height="37"
              viewBox="0 0 40 37"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M35.1641 3.16797L15.8359 24.5197L7 16.5037L2 21.1287L16.6641 34.543L40 6.79297L35.1641 3.16797Z"
                fill="#149557"
              />
            </svg>
          </button>
        </div>
      );
    }
    return (
      <div className="d-flex justify-content-end">
        <button
          className="btn-setting-icon btn-edit"
          onClick={() => setEdit(true)}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.4333 15L25 16.5667L9.86667 31.6667H8.33333V30.1333L23.4333 15ZM29.4333 5C29.0167 5 28.5833 5.16667 28.2667 5.48333L25.2167 8.53333L31.4667 14.7833L34.5167 11.7333C35.1667 11.0833 35.1667 10 34.5167 9.38333L30.6167 5.48333C30.2833 5.15 29.8667 5 29.4333 5ZM23.4333 10.3167L5 28.75V35H11.25L29.6833 16.5667L23.4333 10.3167Z"
              fill="#007bff"
            />
          </svg>
        </button>
      </div>
    );
  };

  const updateConfig = () => {
    const schedule = getShedule();
    if (schedule) {
      schedule[title] = config;
      setStorageItem(constant.STORAGE.sheduleConfig, schedule);
    } else {
      const data = {};
      data[title] = config;
      setStorageItem(constant.STORAGE.sheduleConfig, data);
    }
    setEdit(!edit);
  };

  const render = () => {
    return (
      <div
        className={`d-flex justify-content-between p-1 nvh-gap-2 align-items-end`}
      >
        <div className="px-1 nvh-gap-1 d-flex flex-column ">
          <h6>Start Time</h6>
          <input
            disabled={!edit || recording}
            type="time"
            className="timebox-input"
            value={config.start}
            onChange={(e) => setConfig({ ...config, start: e.target.value })}
          />
        </div>
        <div className="px-1 nvh-gap-1 d-flex flex-column ">
          <h6>End Time</h6>
          <input
            disabled={!edit}
            type="time"
            className="timebox-input"
            value={config.end}
            onChange={(e) => setConfig({ ...config, end: e.target.value })}
          />
        </div>
        <div className="d-flex flex-row align-items-center nvh-gap-2  justify-content-start">
          <input
            disabled={!edit}
            type="checkbox"
            id={`chk-${title}`}
            checked={config.enabled}
            onChange={(e) =>
              setConfig({ ...config, enabled: e.target.checked })
            }
          />
          <label htmlFor={`chk-${title}`} className="">
            {WeekNames[title]}
          </label>
        </div>
        {renderAction()}
      </div>
    );
  };
  return render();
};
